module.exports = __webpack_public_path__ + "static/accesorios-efcdd5bb1bcf239ff8c7930f086f89b7.png";